import { Pipe, PipeTransform } from '@angular/core';
import { ExtendedPosition } from './sb-balance-list.component';

@Pipe({
    name: 'entityConcat',
    standalone: true
})
export class EntityConcatPipe implements PipeTransform {
    transform(
        entities: Array<ExtendedPosition | any>,
        key?: keyof ExtendedPosition
    ): string {
        return [...new Set(entities.map((entity) => (key ? entity[key] : entity)))].join(
            ','
        );
    }
}
